import React from "react";
import "./button.css";

// type => default or primary
const Button = ({ type="default", text="", loading=false, ...custom }) => {
    return (
        <button 
            className={`button-base button-type-${type}`} 
            {...custom}
        >
            {loading ? <i className="fas fa-spinner button-spinner" /> : null}
            {text}
        </button> 
    )
}

export default Button;